import * as $ from 'jquery';
import { setTimeout } from 'timers';
import { Component } from '@angular/core';


export class ExampleComponent {
  isGenerated = false;
  generateInput() {
    this.isGenerated = true;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng-app',
  templateUrl: './example.component.html',
  styleUrls: ['./example.component.css']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
